var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('v-data-table',{attrs:{"items":_vm.items,"search":_vm.search,"headers":_vm.headers}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }